

const Footer = () => {
    return (
        <div className="d-flex justify-content-center text-center">
            <p className="mx-1"><i>Parker Noble 2022.</i></p>
            <a href="https://www.github.com/lithobraking" className="mx-1">GitHub</a>
            <a href="https://www.linkedin.com/moonchaser" className="mx-1">LinkedIn</a>
        </div>
    )
};

export default Footer;